<template lang='pug' src='./accessibility.pug'></template>

<script>
import api from 'api'
import axios from 'axios'
import Loader from 'components/loader/loader'
import ContactSection from 'components/custom/custom-contact/custom-contact'
import FooterMain from 'components/footer/footer-main'

export default {
  name: 'Contact',
  data: () => {
    return {
      name: 'Accessibility',
      props: {},
      message: 'Contact',
      videosource: [],
      loading: true,
      companyName: 'Smile Design Orthodontics', // Fill this in
      domain: "<a href='https://www.smiledesignortho.com'>smiledesignortho.com</a>", // Fill this in
      email: "<a href='mailto:info@smiledesignortho.com'>info@smiledesignortho.com</a>", // Fill this in
      phone: "<a href='tel:1-972-263-1755'>972-263-1755</a>", // Fill this in
      formattedEmail: ''
    }
  },
  created () {
    this.loading = true
    axios.get(api + '/acf/v3/pages/85 ')
      .then(response => {
        this.props = response.data.acf
        this.loading = false
        this.videosource.push(response.data.acf.promo_video_mp4)
        this.videosource.push(response.data.acf.promo_video_webm)
      })
      .catch(e => {
        this.errors.push(e)
        console.log(this.errors.push(e))
        console.log(e)
      })
  },
  components: {
    Loader,
    ContactSection,
    FooterMain
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// accessibility.vue?7dd9395f